import type { FormLocale } from '@jlg-website/shared';
import { ConfirmButton } from '../shared/confirm-button';
import { textFor } from '../shared/copy';
import { NotesField } from '../shared/notes-field';
import { StepBackButton } from '../shared/step-back-button';
import { SummaryRow } from '../shared/summary-row';

type CallNowConfirmStepProps = {
  phone: string;
  notes: string;
  locale: FormLocale;
  submitting: boolean;
  onChangeNotes: (notes: string) => void;
  /** Returns to the question, where the visitor can pick a time instead. */
  onBack: () => void;
  onConfirm: () => void;
};

/**
 * Confirmation of a call back asked for right away. Deliberately its own step rather than the
 * picker's: there is no slot to count down to, so it carries no deadline — only the summary, the
 * notes and the confirmation.
 */
export function CallNowConfirmStep({
  phone,
  notes,
  locale,
  submitting,
  onChangeNotes,
  onBack,
  onConfirm,
}: CallNowConfirmStepProps) {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-center gap-3">
        <StepBackButton onClick={onBack} label={textFor(locale, 'backToQuestion')} />
        <p className="text-sm font-bold text-brand-text-button">
          {textFor(locale, 'confirmTitle')}
        </p>
      </div>

      <SummaryRow summary={textFor(locale, 'callNowSummary')} locale={locale} onChange={onBack} />

      <p className="text-sm text-brand-primary">
        {textFor(locale, 'weWillCall')} <strong className="font-bold">{phone}</strong>.
      </p>

      <NotesField id="call-now-notes" notes={notes} locale={locale} onChange={onChangeNotes} />

      <ConfirmButton locale={locale} disabled={submitting} onClick={onConfirm} />
    </div>
  );
}
